import getScreenType from '@/utils/analytics/getScreenType';
import getUploadAnalyticsSettings from '@/utils/analytics/getUploadAnalyticsSettings';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction } from '@/types/analytics';

/** Send analytics for an upload that failed, with the message it threw. */
const sendUploadFailureAnalytics = (errorMessage: string) => {
  sendAiGenScreenActionAnalytics({
    action: AiGenScreenAction.UPLOAD_FAILURE,
    screen_type: getScreenType(),
    settings: { ...getUploadAnalyticsSettings(), error_message: errorMessage },
  });
};

export default sendUploadFailureAnalytics;
